<template lang="html">
  <transition name="fade" @after-leave="$emit('after-leave')">
    <div class="modal" v-if="show" @click="handleClick">
      <div class="card" :style="{transform: transformY !== 0 ? `translateY(${transformY}%)` : '', transition: transitionEnabled ? 'transform 200ms ease-out' : ''}" @touchstart="swipeStart" @touchend="swipeEnd" @touchmove="swipeUpdate" @mousedown="swipeStart">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      maxSwipeDistance: null,
      swiping: false,
      touchStartY: null,
      transformY: 0,
      transitionEnabled: false,
    };
  },
  methods: {
    handleClick(e) {
      if (this.dismissable && e.target === this.$el) this.$emit('close');
    },
    handleSwipeEnd() {
      if (!this.dismissable) return;
      this.transitionEnabled = true;
      if (this.transformY >= 50) {
        this.transformY = 100;
        this.$emit('close');
      } else this.transformY = 0;
    },
    swipeEnd(e) {
      if (!this.dismissable) return;
      if (this.swiping) this.swiping = false;
      if (e.type === 'mouseup') {
        window.removeEventListener('mousemove', this.swipeUpdate, false);
        window.removeEventListener('mouseup', this.swipeEnd, false);
      }
      this.handleSwipeEnd();
    },
    swipeStart(e) {
      if (!this.dismissable) return;
      const card = e.currentTarget;
      if (card.scrollTop !== 0) return; // we're scrolling

      if (this.transitionEnabled) this.transitionEnabled = false;
      this.swiping = true;
      this.touchStartY = e.type === 'touchstart' ? e.changedTouches[0].clientY : e.clientY;
      this.maxSwipeDistance = window.innerHeight - this.touchStartY;
      if (e.type === 'mousedown') {
        window.addEventListener('mousemove', this.swipeUpdate, false);
        window.addEventListener('mouseup', this.swipeEnd, false);
      }
    },
    swipeUpdate(e) {
      if (!this.swiping) return; // we’re scrolling

      const currentY = e.type === 'touchmove' ? e.changedTouches[0].clientY : e.clientY;
      const distance = currentY - this.touchStartY;

      if (distance > 0) this.transformY = Math.min((distance / this.maxSwipeDistance) * 100, 100);
      else this.transformY = 0;
    },
  },
  props: {
    dismissable: {
      type: Boolean,
      default: true,
    },
    show: Boolean,
  },
  watch: {
    show(newValue) {
      if (!newValue && this.transformY !== 0) this.transformY = 0;
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../styles/colors'
  @require '../styles/shadows'

  .modal
    display: flex
    justify-content: center
    align-items: flex-end
    width: 100%
    height: 100%
    background-color: alpha($black, 0.54)
    position: fixed
    top: 0
    left: 0
    z-index: 9

    &.fade-enter-active,
    &.fade-leave-active
      transition: opacity 200ms ease

      .card
        transition: transform 200ms ease-out

      &.fade-enter,
      &.fade-leave-to
        opacity: 0

        .card
          transform: translateY(100%) !important

    .card
      background-color: $default-light
      background-image: $default-gradient
      color: $text
      border-top-left-radius: 12px
      border-top-right-radius: @border-top-left-radius
      box-shadow: $interactable-reverse
      width: 100%
      max-width: 640px
      max-height: 90%
      padding: 24px
      box-sizing: border-box
      overflow-y: auto
      touch-action: pan-y

      >>>

        h1,
        h2,
        h3,
        h4,
        h5,
        h6
          margin: 0

        h1
          font-size: 2rem
          margin-bottom: 24px

        h2
          font-size: 1rem
          margin-bottom: 16px

        p
          margin-top: 0
          margin-bottom: 16px
          font-weight: normal

        ul
          margin: 0
          margin-bottom: 24px
          padding-left: 1.1rem
          font-weight: normal
</style>
